"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinWrap = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _style = require("../../../style");

var SpinWrap = ( /*#__PURE__*/0, _styledBase.default)('div', {
  target: "euu8g0g0",
  label: "SpinWrap"
})(_style.spinMixin, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1NwaW4vc3R5bGUvaW5kZXguanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSXFDIiwiZmlsZSI6Ii4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1NwaW4vc3R5bGUvaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IHNwaW5NaXhpbiB9IGZyb20gJ3NyYy9zdHlsZSc7XG5cbmV4cG9ydCBjb25zdCBTcGluV3JhcCA9IHN0eWxlZCgnZGl2JylgXG4gICAgJHtzcGluTWl4aW59O1xuYDtcbiJdfQ== */"));
exports.SpinWrap = SpinWrap;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud-fe/react-components/lib/components/Spin/style/index.js
// module id = 1955
// module chunks = 6 7 17 18